import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { AddFindMeFollowMeStepModule } from 'src/app/pages/add-find-me-follow-me-step/add-find-me-follow-me-step.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { FormatPhoneNumberorExtensionPipeModule } from 'src/app/pipes/format-phone-number-or-extension/format-phone-number-pipe.module';
import { FindMeFollowMeStepsComponent } from './extension-find-me-follow-me-steps.component';

@NgModule({
   declarations: [FindMeFollowMeStepsComponent],
   exports: [FindMeFollowMeStepsComponent],
   imports: [
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      FileUrlPipeModule,
      MatCheckboxModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      AddFindMeFollowMeStepModule,
      FormatPhoneNumberorExtensionPipeModule,
      MatChipsModule,
   ],
})
export class ExtensionFindMeFollowMeStepsModule {}
